export const integrationsVoucherGroups = "/integrations/voucher_groups";
